module.exports = {
      id: "linkedin-usage",
      viewBox: "0 0 48 48",
      url: __webpack_public_path__ + "svg-sprite-71cc17c6d762c8495e8a5375f2902e76.svg#linkedin",
      toString: function () {
        return this.url;
      }
    }